import { render, staticRenderFns } from "./ResidentContact.vue?vue&type=template&id=105bf6da&scoped=true&"
import script from "./ResidentContact.vue?vue&type=script&lang=ts&"
export * from "./ResidentContact.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentContact.vue?vue&type=style&index=0&id=105bf6da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105bf6da",
  null
  
)

export default component.exports